// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Checkbox from 'antd/lib/checkbox';

// EXPORTED COMPONENT
// ===================================
export class CheckboxInput extends React.Component {
  render() {
    return <Checkbox {...this.props} />;
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/inputs/CheckboxInput/index.js